import DraggableFloat from './DraggableFloat';

export default DraggableFloat;
